
function CardPersyaratan({imagePath, description}){
    return(
        <div className='card-persyaratan'>
            <img src={require(`../../../../assets/img/product/${imagePath}.png`)} alt='iconImage'/>
            <p><b>{description}</b></p>
        </div>
    );
}
function AllCardIndividu({product}){
    if (product === 'kasbon' || product === 'pinjaman-karyawan') {
        return (
            <div className='card-container'>
                <CardPersyaratan imagePath='persyaratan-individu-1' description='Berkewarganegaraan Indonesia (WNI)'/>
                <CardPersyaratan imagePath='persyaratan-individu-2' description='Berusia 21 - 55 tahun'/>
                <CardPersyaratan imagePath='persyaratan-individu-3' description='Memiliki email, nomor HP, dan WhatsApp yang aktif'/>
                <CardPersyaratan imagePath='persyaratan-individu-4' description='Memiliki e-KTP pribadi'/>
                <CardPersyaratan imagePath='persyaratan-individu-5' description='Memiliki NPWP (jika ada)'/>
                <CardPersyaratan imagePath='persyaratan-individu-6' description='Karyawan aktif'/>
                <CardPersyaratan imagePath='persyaratan-individu-7' description='Bekerja di perusahaan yang merupakan mitra Danai.id'/>
            </div>
        );
    } else {
        return (
            <div className='card-container'>
                <CardPersyaratan imagePath='persyaratan-individu-1' description='Berkewarganegaraan Indonesia (WNI)'/>
                <CardPersyaratan imagePath='persyaratan-individu-2' description='Berusia 21 - 55 tahun'/>
                <CardPersyaratan imagePath='persyaratan-individu-3'
                                 description='Memiliki email, nomor HP, dan WhatsApp yang aktif'/>
                <CardPersyaratan imagePath='persyaratan-individu-4' description='Memiliki e-KTP pribadi'/>
                <CardPersyaratan imagePath='persyaratan-individu-5' description='Memiliki NPWP'/>
                <CardPersyaratan imagePath='persyaratan-individu-8' description='Terbuka untuk umum, termasuk karyawan, wiraswasta dan profesional'/>
            </div>
        );
    }
}

function AllCardProduktif() {
    return (
        <div className='card-container'>
            <CardPersyaratan imagePath='persyaratan-icon-1'
                             description='Badan Usaha / Badan Hukum yang sesuai dengan Peraturan Perundang-undangan yang berlaku'/>
            <CardPersyaratan imagePath='persyaratan-icon-2'
                             description='Perorangan berusia 21 - 65 tahun saat pinjaman lunas'/>
            <CardPersyaratan imagePath='persyaratan-icon-3' description='Lama usaha lebih dari 3 tahun'/>
        </div>
    );
}

export default function PersyaratanPinjaman({type = '', product = ''}) {
    return (
        <div className={`container-alur persyaratan-pinjaman ${type === 'individu' ? 'individu' : 'produktif'}`}>
            {type !== 'individu'
                ? <AllCardProduktif/>
                : product === 'kasbon'
                    ? <AllCardIndividu product='kasbon'/>
                    : product === 'pinjaman-karyawan'
                        ? <AllCardIndividu product='pinjaman-karyawan'/>
                        : <AllCardIndividu/>
            }
            <div className='text-container'>
                <h2 className='text-header'>Persyaratan Pinjaman</h2>
            </div>
        </div>
    );
}